export default "__VITE_ASSET__Bdx51ym3__"